import Core from "@/modules/core/service/Core";

const url = {
    setFavoriteContact: "/api/disposition/inspection/{0}/contact/{1}",
    current: "/api/disposition/unit/{0}"
}
export default {
    getCurrentInspection (unitId) {
        return Core.method.get(url.current, unitId);
    },

    setFavoriteContact (inspection, contactId) {
        return Core.method.putVoid(url.setFavoriteContact, null, inspection.unit.id, contactId);
    }
}